import { Avatar } from '@latitude/avatar';
import { Button } from '@latitude/button';
import { CardListItem } from '@latitude/card-list-item';
import { IconButton } from '@latitude/icon-button';
import { Icon, type IconName } from '@latitude/icons';
import type { FC } from 'react';

type Props = {
  title: string;
  description: string;
  ctaLabel: string;
  iconName: IconName;
  isComplete: boolean;
  isDisabled?: boolean;
  onOpen: () => void;
};

const TaxCertificationComponent: FC<Props> = ({
  title,
  description,
  ctaLabel,
  iconName,
  isComplete,
  isDisabled = false,
  onOpen,
}) => (
  <CardListItem
    size="medium"
    data-testid="tax-certification-card"
    className="items-center"
    leading={
      <Avatar
        size="small"
        type="icon"
        variant="strong"
        icon={<Icon name={iconName} />}
      />
    }
    title={title}
    subtitle={description}
    trailing={
      isComplete ? (
        <IconButton
          variant="strong"
          type="ghost"
          size="tiny"
          icon={<Icon name="edit" />}
          aria-label="Edit tax certification"
          disabled={isDisabled}
          onClick={onOpen}
          data-testid="tax-certification-edit-button"
        />
      ) : (
        <Button
          variant="strong"
          type="outline"
          size="tiny"
          disabled={isDisabled}
          onClick={onOpen}
          data-testid="tax-certification-complete-button"
        >
          {ctaLabel}
        </Button>
      )
    }
  />
);

export { TaxCertificationComponent };
